<template>
    <div id="billingForcastReport" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Billing Forecast Detail Report</div>
                    <div class="web-action-btn text-right">
                        <div class="bill-date-header" v-if="billDate != '' && billDate != undefined">Bill Date : {{billDate}}</div>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link class="btn btn-secondary" v-bind:to="{name: 'BillingForecastReport'}">
                            <i class="fp-back"> </i> Back
                        </router-link>
                        <a v-if="$route.query.from == undefined" href="javascript:void(0)" class="btn btn-primary" v-on:click="confirmInvoice()">
                            <i class="fp-accounting"> </i> Confirm
                        </a>
                        <a v-if="$route.query.from != undefined && $route.query.from == 'confirmed'" href="javascript:void(0)" class="btn btn-secondary" v-on:click="openBillDateModal()">
                            <i class="fp-accounting"> </i> Post Invoice
                        </a>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <router-link class="btn btn-secondary" v-bind:to="{name: 'BillingForecastReport'}">
                            <i class="fp-back"> </i> Back
                        </router-link>
                        <button type="button" class="btn" data-toggle="dropdown" data-toggle-position="left" aria-expanded="true" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li v-if="$route.query.from == undefined">
                                    <a href="javascript:void(0)" class="" v-on:click="confirmInvoice()">
                                        Confirm
                                    </a>
                                </li>
                                <li v-if="$route.query.from != undefined && $route.query.from == 'confirmed'">
                                    <a href="javascript:void(0)" class="" v-on:click="openBillDateModal()">
                                        Post Invoice
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)" class="" v-on:click="exportReports()">
                                        Export
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="bill-date-header" v-if="billDate != '' && billDate != undefined">Bill Date : {{billDate}}</div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content billing-forecast-detail">
                        <data-table-filter-config :moduleName="'listBillingDetailForecast'" ref="filterBillingDetailForecast" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processBatchMsg">Current batch {{batchNum}} is processing please wait!</p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :position="'top'"
                                        :moduleName="'billingForecastDetailList'" ref="paginateComponent">
                                </custom-pagination>

                                    <vue-good-table
                                        ref="billingForecastDetailReport"
                                        mode="remote"
                                        title="Billing Forecast Detail Report"
                                        @on-page-change="onPageChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-select-all="onSelectAll"
                                        @on-sort-change="onSortChange"
                                        :totalRows="totalRecords"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :pagination-options="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :sort-options="{
                                            enabled: true
                                        }"
                                        :search-options="{
                                            enabled: false,
                                        }">
                                        <div slot="selected-row-actions">
                                            <button id="deleteForecastDetailBtn" v-on:click.prevent="forecastDetailDelete" class="btn btn-primary">Delete</button>
                                        </div>
                                    </vue-good-table>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange"
                                        :moduleName="'billingForecastDetailList'">
                                </custom-pagination>
                        </section>
                        <div class="modal fade make-bill-date-modal" id="postInvoiceModal" ref="postInvoiceModal" data-backdrop="static" data-keyboard="false" aria-labelledby="makePaymentModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Post Invoice</h5>
                                        <button type="button" class="close" id="btnBillModalClose" v-on:click="hideBillModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="form-row">
                                            <div class="col form-group">
                                                <label class="control-label require" for="bill_date">Bill Date:</label>
                                                <div class="input-group">
                                                    <date-picker placeholder="MM/DD/YYYY" id="bill_date" name="bill_date" v-model="bill_date" :config="optionsDate"></date-picker>
                                                    <label for="bill_date" class="fp-calendar input-calender-icon"></label>
                                                </div>
                                                <div class="field-error">{{ bill_date_error }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-primary" id="btnPostInvoiceModalProcess" v-on:click.once="postInvoice('draft')" :key="buttonKey"> Draft Invoice </button>
                                        <button class="btn btn-primary" id="btnPostInvoiceModalProcess" v-on:click.once="postInvoice('bill')" :key="buttonKey"> Post Invoice </button>
                                        <button class="btn btn-tertiary" id="btnPostInvoiceModalCancel" v-on:click="hideBillModal()"> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

//import EventBus from "./event-bus";
import Vue from "vue";


import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import {dataTableMixins} from '../../mixins/dataTableMixins';
import VueSSE from 'vue-sse'
Vue.use(VueSSE);
// import Echo from "laravel-echo";
    // import VueSocketIO from 'vue-socket.io'

// window.io = require('socket.io-client');
let msgServer
    export default {
        name: "billingForcastReport",
        metaInfo() {
            return {
                title: "Billing Forecast Detail Report | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,contractMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: true,
            userColumns:[],
            columns: [
                {
                    label: 'Customer',
                    field: 'customer',
                    filterable: true,
                    hidden: false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract#',
                    field: 'contractNo',
                    filterable: true,
                    hidden: false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Contract Type',
                    field: 'conType',
                    filterable: true,
                    hidden: false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit',
                    field: 'unit',
                    filterable: true,
                    hidden: false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Amount',
                    field: 'amount',
                    filterable: true,
                    hidden: false,
                    type: "number",
                    fpFieldType:"integer",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reading Found',
                    field: 'readingFound',
                    filterable: true,
                    hidden: false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Reading Found", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Billing Period',
                    field: 'bill_period',
                    filterable: false,
                    sortable:false,
                    hidden: false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Reading Found", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Rate Summary',
                    field: 'rates',
                    filterable: false,
                    hidden: false,
                    type: "text",
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },

            ],
            rows: [],
            selectedDate:"",
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            customer_value: false,
            loading:false,
            optionsDate:{
                            format: 'MM/DD/YYYY',
                            useCurrent: false,
                        },
            days:'',
            action:'list',
            batchProcess:false,
            batchId:0,
            batchNum:'',
            billDate:'',
            from:'',
            forecastId:0,
            bill_date_error:'',
            bill_date:'',
            batchError:false,
            batchErrorMsg:"",
            postOnce:0,
            buttonKey:1

        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'billing_forecast_report') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            }

        },
        created : function () {
            let self = this;
        },
        beforeDestroy() {
            // Make sure to close the connection with the events server
            // when the component is destroyed, or we'll have ghost connections!
            msgServer.close();
        },
        mounted: function() {
            var self = this;
            self.getPermissions();

            if (self.$route.query.from != undefined){

                self.from = self.$route.query.from;

            }else{
                self.forecastId = self.$route.params.id;
            }
            // this.loadList();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.billingForecastDetailReport.unselectAllInternal();
            },
            exportReports: function() {
                var self = this;
                this.action = "export";
                this.loadList();
            },
             checkBatchStatus:function(){
                var self =  this;

                //  $.ajax({
                //     url: process.env.ROOT_API + "/check/batch-status/"+self.batchId,
                //     type: "GET",
                //     crossDomain: true,
                //     headers: {
                //         'Accept': 'application/json',
                //         "Authorization": "Bearer "+localStorage.getItem("tkn"),
                //         'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                //         "Cache-Control": "no-cache"
                //     },
                //     success: function(data) {
                //         self.loading = false;

                //         window.Echo.channel('batchStatus').listen('BatchStatusEvent', (e) => {
                //             console.log(e);
                //             if (e.status && (e.status == 1 || e.status == 2) ){
                //                 self.batchProcess = false;
                //                 self.loadList();
                //             }
                //         });
                //     },
                //     error: function(jqXHR, exception) {
                //         self.loading = false;
                //         self.generateStatusCodeMessage(jqXHR,false,'invoice-list');
                //     }
                // });

                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batchProcess = false;
                            self.loadList();
                            sse.close();
                        }else if (data.status == "2") {
                            self.batchProcess = false;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },
            selectionChanged(param) {

                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
            },

            postInvoice(flag) {
                var self = this;
                // var forecastId = self.$route.params.id;
                self.bill_date_error = '';

                if (self.bill_date == '' || self.bill_date == null){
                    self.bill_date_error = 'Bill Date Required';
                    self.buttonKey++;
                    return;
                }

                if (self.postOnce == 1){
                    return;
                }
                self.postOnce = 1;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/billing-forecast/post",
                    type: "POST",
                    data: {
                        // forecast_id:forecastId,
                        bill_date:self.bill_date,
                        flag:flag
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.postOnce = 0;
                        self.loading = false;
                        self.buttonKey++;
                        if (data.status == "success") {

                            if (data.code == 201){

                                self.batchProcess = true;
                                self.batchId = data.batchId;
                                self.checkBatchStatus();

                                $("#postInvoiceModal").modal("hide");
                                setTimeout(function(){
                                    $("#processBatchMsg").text('');
                                    $("#processBatchMsg").text(data.message);
                                },100);
                            }else{
                                self.batchNum = data.batchNumber;
                                self.batchId = data.batchId;
                                self.batchProcess = true;
                                self.checkBatchStatus();
                                self.bill_date = '';
                                self.bill_date_error = '';
                                $("#postInvoiceModal").modal("hide");
                            }

                        }else{
                            $("#postInvoiceModal").modal("hide");
                            self.$swal('',data.message,'info');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.postOnce = 0;
                        self.buttonKey++;
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadList() {

                var data = this.$refs['billingForecastDetailReport'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['billingForecastDetailReport'].selectedRows[i].id)
                }

                var filterArr = {};

                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    forecastId:self.forecastId,
                    action:self.action,
                    id:use,
                    from:self.from,
                    selectedAll:self.serverParams.selectedAll
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/billing-forecast-details/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if ( self.action == "export" ) {

                                self.action = "list";
                                if ( data.code == "201" ) {
                                     setTimeout(function() {
                                        alert(data.message);
                                    },100);
                                } else {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);
                                    self.cancelAll(true);
                                    self.loadList();

                                }
                            }else if ( self.action == "delete" ) {

                            self.action = "list";
                            self.$refs.filterBillingDetailForecast.clearSelectAll();
                            self.$swal('',data.message,'success');
                            self.loadList();
                            // return;
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.billDate = data.content.billDate;
                            }

                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.billDate = data.content.billDate;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
             },

             forecastDetailDelete:function(){
                var data = this.$refs['billingForecastDetailReport'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['billingForecastDetailReport'].selectedRows[i].id)
                }
                 self.$swal({
                    title: 'Are you sure that you want to delete this forecast detail?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.action = 'delete';
                      self.loadList();

                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete forecast detail? ')) {
                // }
             },
             hideBillModal() {
                var self = this;
                $("#postInvoiceModal").modal("hide");
                self.bill_date = '';
                self.bill_date_error = '';
            },
            openBillDateModal: function(){
                var self = this;
                $("#postInvoiceModal").modal("show");
            },

            confirmInvoice() {
                var self = this;
                var forecastId = self.$route.params.id;

                var data = self.$refs['billingForecastDetailReport'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(self.$refs['billingForecastDetailReport'].selectedRows[i].id);
                }

                var dataField = {};
                if(use.length > 0) {

                  dataField = {
                        forecast_id:forecastId,
                        billDate:self.billDate,
                        ids: use,
                        selectedAll:self.serverParams.selectedAll
                    };

                } else {

                  dataField = {
                        forecast_id:forecastId,
                        billDate:self.billDate,
                        filters: self.serverParams.columnFilters,
                        selectedAll:self.serverParams.selectedAll
                    };

                }

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/billing-forecast/confirm",
                    type: "POST",
                    data: dataField,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                          self.$swal('',"Billing Forecast Detail Confirmed Successfully.",'success');
                          self.action = 'list';
                          self.loadList();
                        }else{

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

        }
    };
</script>

<style scope>
.bill-date-header {
	float: right;
	margin: 0px 15px 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/BillingForecastDetailList.vue